import { TGeneralImport } from '../../type/import';
import actionTypes from './actionType';

export const fetch = (response: TGeneralImport) => ({ type: actionTypes.FETCH, response });

export type Actions =
| ReturnType<typeof fetch>
